export interface IWizardStep {
    stepNumber : number;
    state : WizardStateEnum;
    title : string;
    description : string;
    identifier : string;
}

export enum WizardStateEnum {
    active = "active",
    pristine = "pristine",
    error = "error",
    complete = "complete"
}

export enum StepperActionEnum {
    next,
    previous
}